import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable, produce } from 'immer';
import { OrderedSet } from 'immutable';

import dayjs from '../../core/configs/dayjs';

interface IInternalMetadataEntity {
	id: number;
	label: string;
	description: string;
	tags: OrderedSet<AppTagItemEntity>;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	createdBy: AvatarEntity | null;
	updatedBy: AvatarEntity | null;
	picId: number | null;
}

const entityDefaults: IInternalMetadataEntity = {
	id: -1,
	label: '',
	description: '',
	tags: OrderedSet(),
	creationDate: null,
	updateDate: null,
	createdBy: null,
	updatedBy: null,
	picId: null,
};

export class InternalMetadataEntity implements IInternalMetadataEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public description = entityDefaults.description;
	public tags = entityDefaults.tags;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;
	public createdBy = entityDefaults.createdBy;
	public updatedBy = entityDefaults.updatedBy;
	public picId = entityDefaults.picId;

	public static build(
		params: Partial<IInternalMetadataEntity> = {}
	): InternalMetadataEntity {
		const instance = new InternalMetadataEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.description = params.description ?? entityDefaults.description;
		instance.tags = params.tags ?? entityDefaults.tags;
		instance.creationDate = params.creationDate ?? entityDefaults.creationDate;
		instance.updateDate = params.updateDate ?? entityDefaults.updateDate;
		instance.createdBy = params.createdBy ?? entityDefaults.createdBy;
		instance.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		instance.picId = params.picId ?? entityDefaults.picId;

		return instance;
	}

	public setDefaultLabel(datablockLabel: string): InternalMetadataEntity {
		return produce(this, (draft) => {
			draft.label = `Abonnnement - ${datablockLabel}`;
		});
	}

	public isEqualTo(metadata: InternalMetadataEntity): boolean {
		if (metadata.label !== this.label) {
			return false;
		} else if (metadata.description !== this.description) {
			return false;
		} else if (metadata.tags.size !== this.tags.size) {
			return false;
		} else if (metadata.picId !== this.picId) {
			return false;
		}
		return true;
	}
}
